import { Box, Text, TextProps } from '@mantine/core';
import { ReactNode } from 'react';

import { InteractiveTooltip } from './InteractiveTooltip';
import { Tooltip, TooltipProps } from './Tooltip';

type UnderlineTooltipProps = {
  tooltipProps?: Omit<TooltipProps, 'children' | 'label'>;
  textProps?: Omit<TextProps, 'children'>;
  label: ReactNode;
  children: ReactNode;
  /** Render over `InteractiveTooltip` so the label can be hovered and scrolled */
  isInteractive?: boolean;
  /** Max width of the interactive dropdown */
  maw?: number | string;
};

export const UnderlineTooltip = ({
  tooltipProps,
  textProps,
  label,
  children,
  isInteractive = false,
  maw,
}: UnderlineTooltipProps) => {
  const trigger = (
    <Text
      {...textProps}
      style={{
        ...textProps?.style,
        textDecorationLine: 'underline',
        textDecorationStyle: 'dashed',
        textUnderlineOffset: '4px',
      }}
    >
      {children}
    </Text>
  );

  return (
    <Box display="inline-block" w="max-content">
      {isInteractive ? (
        <InteractiveTooltip
          position="top"
          content={label}
          shouldStopPropagation={tooltipProps?.shouldStopPropagation}
          maw={maw}
        >
          {trigger}
        </InteractiveTooltip>
      ) : (
        <Tooltip
          {...tooltipProps}
          position="top"
          arrowPosition="center"
          label={label}
          inline
        >
          {trigger}
        </Tooltip>
      )}
    </Box>
  );
};
